(function () {
  'use strict';

  const routes = window.routes || {};
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  const moneyFormat = window.Shopify && Shopify.money_format ? Shopify.money_format : null;
  const formatMoney = (cents) => {
    const value = Number(cents || 0);
    if (moneyFormat && window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(value, moneyFormat);
    }
    return (value / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: document.documentElement.dataset.currency || 'PKR',
      maximumFractionDigits: 0
    });
  };

  const drawer = $('#cartDrawer');
  const search = $('#predictiveSearch');
  const quick = $('#quickViewModal');
  const mobileMenu = $('#mobileMenu');
  const toast = createToast();

  let activeQuickProduct = null;
  let selectedQuickOptions = [];
  let quickLastFocus = null;
  let searchTimer;
  let cartRequest = null;
  let cartMutationPromise = null;
  let cartMutationInFlight = false;

  function createToast() {
    let el = $('#noyaToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'noyaToast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText = [
        'position:fixed',
        'right:18px',
        'bottom:18px',
        'z-index:10000',
        'max-width:340px',
        'padding:12px 15px',
        'border-radius:5px',
        'background:#1A1918',
        'color:#fff',
        'font:600 11px/1.4 "Plus Jakarta Sans",Arial,sans-serif',
        'box-shadow:0 12px 35px rgba(0,0,0,.18)',
        'opacity:0',
        'transform:translateY(12px)',
        'pointer-events:none',
        'transition:opacity .22s ease,transform .22s ease'
      ].join(';');
      document.body.appendChild(el);
    }
    return el;
  }

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(12px)';
    }, 2800);
  }

  function setBodyLock(locked) {
    document.body.classList.toggle('overflow-hidden', locked);
  }

  function isSearchOpen() {
    return !!search && !search.classList.contains('opacity-0');
  }

  function isMobileMenuOpen() {
    return !!mobileMenu && !mobileMenu.classList.contains('opacity-0');
  }

  function openSearch() {
    if (!search) return;
    if (drawer?.classList.contains('is-open')) closeCart();
    if (quick?.classList.contains('is-open')) closeQuickLayer();
    search.classList.remove('pointer-events-none', 'opacity-0');
    search.setAttribute('aria-hidden', 'false');
    setBodyLock(true);
    requestAnimationFrame(() => $('#PredictiveSearchInput')?.focus());
  }

  function closeSearch() {
    if (!search) return;
    search.classList.add('pointer-events-none', 'opacity-0');
    search.setAttribute('aria-hidden', 'true');
    if (!quick?.classList.contains('is-open') && !drawer?.classList.contains('is-open') && !isMobileMenuOpen()) {
      setBodyLock(false);
    }
  }

  function openCart() {
    if (!drawer) return;
    if (quick?.classList.contains('is-open')) closeQuickLayer();
    if (isSearchOpen()) closeSearch();
    if (isMobileMenuOpen()) setMobileMenu(false);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setBodyLock(true);
    if (!drawer.dataset.cartLoaded) refreshCart().catch(() => {});
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!quick?.classList.contains('is-open') && !isSearchOpen() && !isMobileMenuOpen()) {
      setBodyLock(false);
    }
  }

  function openQuickLayer() {
    if (!quick) return;
    quick.classList.add('is-open');
    quick.setAttribute('aria-hidden', 'false');
    setBodyLock(true);
    requestAnimationFrame(() => $('#quickViewModal [data-close-quick-view]')?.focus());
  }

  function closeQuickLayer() {
    if (!quick) return;
    quick.classList.remove('is-open');
    quick.setAttribute('aria-hidden', 'true');
    if (quickLastFocus && typeof quickLastFocus.focus === 'function') quickLastFocus.focus();
    quickLastFocus = null;
    if (!drawer?.classList.contains('is-open') && !isSearchOpen() && !isMobileMenuOpen()) {
      setBodyLock(false);
    }
  }

  function setMobileMenu(open) {
    if (!mobileMenu) return;
    const panel = mobileMenu.querySelector('[data-mobile-menu-panel]');
    mobileMenu.classList.toggle('pointer-events-none', !open);
    mobileMenu.classList.toggle('opacity-0', !open);
    mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (panel) panel.classList.toggle('-translate-x-full', !open);
    const trigger = $('#mobileMenuOpen');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    setBodyLock(open);
  }

  function updateCartBadges(count) {
    $$('[data-cart-badge], #cartBadge').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
      if (count > 0) el.classList.add('flex');
    });
    const quickCount = $('[data-cart-count-badge]', drawer);
    if (quickCount) quickCount.textContent = count;
  }

  function updateShippingProgress(totalPrice) {
    const progress = $('[data-shipping-progress]', drawer);
    const message = $('[data-shipping-message]', drawer);
    const bar = $('[data-shipping-progress-bar]', drawer);
    if (!progress) return;

    const threshold = Number(window.themeSettings?.freeShippingThreshold || 500000);
    const remaining = Math.max(0, threshold - totalPrice);

    if (message) {
      if (totalPrice >= threshold) {
        message.innerHTML = '🚚 Free Nationwide Shipping — Unlocked!';
      } else {
        message.innerHTML = `Add <strong>${formatMoney(remaining)}</strong> more for free nationwide shipping.`;
      }
    }

    if (bar) {
      bar.style.width = `${Math.min(100, threshold ? (totalPrice / threshold) * 100 : 100)}%`;
    }
  }

  function renderCart(cart) {
    if (!drawer) return;
    drawer.dataset.cartLoaded = 'true';

    const count = $('[data-cart-count]', drawer);
    const total = $('[data-cart-total]', drawer);
    const items = $('[data-cart-items]', drawer);

    if (count) count.textContent = cart.item_count;
    if (total) total.textContent = formatMoney(cart.total_price);

    updateShippingProgress(cart.total_price);
    updateCartBadges(cart.item_count);

    if (!items) return;

    if (!cart.items.length) {
      items.innerHTML = `
        <div class="noya-cart-empty">
          <div class="noya-cart-empty__icon" aria-hidden="true">♡</div>
          <h3>Your shopping bag is empty</h3>
          <p>Discover something beautiful for your home.</p>
          <a href="${routes.all_products_collection_url || '/collections/all'}">Explore products</a>
        </div>`;
      return;
    }

    items.innerHTML = cart.items.map((item, index) => `
      <article class="noya-cart-item" data-cart-item data-line="${index + 1}" data-quantity="${item.quantity}">
        <a href="${item.url}" class="noya-cart-item__image-link">
          <img src="${item.image || ''}" alt="${escapeHtml(item.product_title)}" width="70" height="84" class="noya-cart-item__image" loading="lazy">
        </a>
        <div class="noya-cart-item__details">
          <h3><a href="${item.url}">${escapeHtml(item.product_title)}</a></h3>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
          <strong>${formatMoney(item.final_line_price)}</strong>
          <div class="noya-cart-item__bottom">
            <div class="noya-line-quantity">
              <button type="button" data-cart-decrease data-line="${index + 1}" aria-label="Decrease quantity">−</button>
              <span data-line-quantity>${item.quantity}</span>
              <button type="button" data-cart-increase data-line="${index + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="noya-cart-item__remove" data-cart-remove data-line="${index + 1}">Remove</button>
          </div>
        </div>
      </article>`).join('');
  }

  function shopifyRoot() {
    const value = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || routes.root_url || '/';
    return value.endsWith('/') ? value : `${value}/`;
  }

  async function getCart() {
    if (cartRequest) return cartRequest;
    const url = `${shopifyRoot()}cart.js`;
    cartRequest = fetch(url, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(async (response) => {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .finally(() => { cartRequest = null; });
    return cartRequest;
  }

  async function changeCart(line, quantity) {
    const endpoint = `${shopifyRoot()}cart/change.js`;
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, quantity })
    });
    if (!response.ok) throw new Error('Unable to update cart');
    return response.json();
  }

  function runCartMutation(task) {
    if (cartMutationPromise) return cartMutationPromise;
    cartMutationInFlight = true;
    cartMutationPromise = Promise.resolve().then(task).finally(() => {
      cartMutationInFlight = false;
      cartMutationPromise = null;
    });
    return cartMutationPromise;
  }

  async function addToCart(variantId, quantity = 1) {
    return runCartMutation(async () => {
      const endpoint = `${shopifyRoot()}cart/add.js`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: Math.max(1, Number(quantity) || 1) }]
        })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Unable to add this item to your bag.');
      }

      const cart = await getCart();
      renderCart(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      return cart;
    });
  }

  async function refreshCart() {
    const cart = await getCart();
    renderCart(cart);
    if (drawer) drawer.dataset.cartLoaded = 'true';
    return cart;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[char]));
  }

  function renderQuickImages(product) {
    const main = $('#quickViewImg');
    const thumbs = $('#quickViewThumbs');
    if (!main || !thumbs) return;

    const images = Array.isArray(product.images) ? product.images : [];
    thumbs.innerHTML = '';

    if (!images.length) {
      main.removeAttribute('src');
      return;
    }

    const setImage = (src, button) => {
      main.src = src;
      main.alt = product.title;
      $$('#quickViewThumbs button').forEach((item) => item.classList.remove('is-active'));
      button?.classList.add('is-active');
    };

    images.forEach((src, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `View product image ${index + 1}`);
      if (index === 0) button.classList.add('is-active');

      const image = document.createElement('img');
      image.src = src;
      image.alt = `${product.title} image ${index + 1}`;
      image.loading = 'lazy';
      button.appendChild(image);
      button.addEventListener('click', () => setImage(src, button));
      thumbs.appendChild(button);
    });

    main.src = images[0];
    main.alt = product.title;
  }


  function hasPositiveStock(product) {
    return Array.isArray(product?.variants)
      && product.variants.some((variant) => (
        variant?.available && Number(variant?.inventory_quantity || 0) > 0
      ));
  }

  function isUsableVariant(product, variant) {
    if (!variant || !variant.available) return false;
    return !hasPositiveStock(product) || Number(variant.inventory_quantity || 0) > 0;
  }

  function findQuickVariant() {
    if (!activeQuickProduct) return null;
    return activeQuickProduct.variants.find((variant) =>
      variant.options.every((value, index) => selectedQuickOptions[index] === value)
    ) || null;
  }

  function updateQuickView() {
    const product = activeQuickProduct;
    if (!product) return;

    const variant = findQuickVariant();
    const price = $('#quickViewPrice');
    const compare = $('#quickViewCompare');
    const sale = $('#quickViewSale');
    const idInput = $('#quickViewVariant');
    const addButton = $('#quickViewAdd');
    const quantity = $('#quickViewQuantity');

    if (price) price.textContent = variant ? formatMoney(variant.price) : 'Unavailable';

    if (compare) {
      compare.textContent = variant?.compare_at_price > variant?.price
        ? formatMoney(variant.compare_at_price)
        : '';
    }

    if (sale) {
      sale.hidden = !(variant?.compare_at_price > variant?.price);
    }

    if (idInput) idInput.value = variant?.id || '';
    if (addButton) {
      addButton.disabled = !isUsableVariant(activeQuickProduct, variant);
      addButton.textContent = isUsableVariant(activeQuickProduct, variant) ? 'ADD TO SHOPPING BAG' : 'SOLD OUT';
    }

    if (quantity) quantity.disabled = !isUsableVariant(activeQuickProduct, variant);

    if (variant?.featured_image?.src) {
      const main = $('#quickViewImg');
      if (main) main.src = variant.featured_image.src;
    }

    // Keep unavailable combinations disabled while preserving the current selection.
    $$('.noya-qv-option__values button', quick).forEach((button) => {
      const optionIndex = Number(button.dataset.optionIndex);
      const value = button.dataset.optionValue;
      const possible = activeQuickProduct.variants.some((candidate) => {
        if (!isUsableVariant(activeQuickProduct, candidate)) return false;
        return candidate.options.every((candidateValue, index) => {
          if (index === optionIndex) return candidateValue === value;
          return selectedQuickOptions[index] === candidateValue;
        });
      });
      button.disabled = !possible;
    });
  }

  function renderQuickOptions(product) {
    const wrapper = $('#quickViewOptions');
    if (!wrapper) return;
    wrapper.innerHTML = '';

    (product.options || []).forEach((option, optionIndex) => {
      const group = document.createElement('div');
      group.className = 'noya-qv-option';

      const label = document.createElement('span');
      label.className = 'noya-qv-option__label';
      label.textContent = option.name;

      const values = document.createElement('div');
      values.className = 'noya-qv-option__values';

      option.values.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = value;
        button.dataset.optionIndex = String(optionIndex);
        button.dataset.optionValue = value;
        button.setAttribute('aria-pressed', selectedQuickOptions[optionIndex] === value ? 'true' : 'false');

        if (selectedQuickOptions[optionIndex] === value) button.classList.add('is-selected');

        button.addEventListener('click', () => {
          selectedQuickOptions[optionIndex] = value;
          $$('.noya-qv-option__values button', group).forEach((item) => {
            const selected = item.dataset.optionValue === value;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          updateQuickView();
        });

        values.appendChild(button);
      });

      group.append(label, values);
      wrapper.appendChild(group);
    });

    updateQuickView();
  }

  async function openQuickView(url, trigger) {
    if (!quick || !url) return;

    quickLastFocus = trigger || document.activeElement;
    quick.classList.add('is-loading');

    try {
      const response = await fetch(`${url}.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Product unavailable');

      const product = await response.json();
      const firstAvailable = product.variants.find((variant) => isUsableVariant(product, variant)) || product.variants.find((variant) => variant.available) || product.variants[0];

      activeQuickProduct = product;
      selectedQuickOptions = firstAvailable?.options ? [...firstAvailable.options] : [];

      const vendor = $('#quickViewVendor');
      const title = $('#quickViewTitle');
      const description = $('#quickViewDesc');
      const link = $('#quickViewLink');
      const rating = $('#quickViewRating');

      if (vendor) vendor.textContent = product.vendor || 'Zenoa Home Textiles';
      if (title) title.textContent = product.title;
      if (description) description.innerHTML = product.description || '<p>No additional product description is available.</p>';
      if (link) link.href = product.url || url;

      if (rating) rating.hidden = true;

      renderQuickImages(product);
      renderQuickOptions(product);

      const quantity = $('#quickViewQuantity');
      if (quantity) quantity.value = '1';

      updateQuickView();
      quick.classList.remove('is-loading');
      openQuickLayer();
    } catch (error) {
      quick.classList.remove('is-loading');
      window.location.href = url;
    }
  }

  function initWishlist() {
    let saved = [];
    try {
      saved = JSON.parse(localStorage.getItem('noyaWishlist') || '[]');
      if (!Array.isArray(saved)) saved = [];
    } catch (_) {
      saved = [];
    }

    const sync = () => {
      const badge = $('#wishlistBadge');
      if (badge) {
        badge.textContent = saved.length;
        badge.classList.toggle('hidden', saved.length === 0);
        badge.classList.toggle('flex', saved.length > 0);
      }

      $$('[data-wishlist-toggle]').forEach((button) => {
        const id = String(button.closest('[data-product-card]')?.dataset.productId || '');
        button.setAttribute('aria-pressed', saved.includes(id) ? 'true' : 'false');
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist-toggle]');
      if (!button) return;

      const id = String(button.closest('[data-product-card]')?.dataset.productId || '');
      if (!id) return;

      saved = saved.includes(id)
        ? saved.filter((item) => item !== id)
        : [...saved, id];

      localStorage.setItem('noyaWishlist', JSON.stringify(saved));
      sync();
      showToast(saved.includes(id) ? 'Added to your wishlist.' : 'Removed from your wishlist.');
    });

    $('#wishlistOpen')?.addEventListener('click', () => {
      showToast(saved.length ? `${saved.length} item${saved.length === 1 ? '' : 's'} saved in your wishlist.` : 'Your wishlist is empty.');
    });

    sync();
  }

  function initProductForms() {
    $$('[data-product-section]').forEach((section) => {
      const form = $('[data-product-form]', section);
      const jsonEl = $('[data-product-json]', section);
      if (!form || !jsonEl) return;

      let product;
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (_) {
        return;
      }

      const inputs = $$('.product-option-input', form);
      const idInput = $('[data-variant-id]', form);
      const priceBox = $('#ProductPrice', section);
      const addButton = $('[data-add-to-cart]', form);
      const label = $('[data-add-label]', form);
      const mainImage = $('#ProductMainImage', section);

      const sync = () => {
        // A product with only one default variant has no option inputs.
        // In that case, use Shopify's first available variant directly.
        if (!inputs.length) {
          const variant = product.variants.find((candidate) => candidate.available) || product.variants[0];

          if (!variant) {
            if (addButton) addButton.disabled = true;
            if (label) label.textContent = 'Unavailable';
            return;
          }

          if (idInput) idInput.value = variant.id;

          if (priceBox) {
            const price = formatMoney(variant.price);
            const compare = variant.compare_at_price > variant.price
              ? `<span class="text-sm text-[#8C7B6B] line-through">${formatMoney(variant.compare_at_price)}</span>`
              : '';
            priceBox.innerHTML = `<span class="text-2xl font-bold text-[#1A1918]">${price}</span>${compare}<span class="text-[10px] bg-[#E8DFD1] text-[#1A1918] font-bold px-2 py-0.5 rounded uppercase">Cash on Delivery</span>`;
          }

          if (addButton) addButton.disabled = !isUsableVariant(product, variant);
          if (label) label.textContent = isUsableVariant(product, variant) ? 'Add to Shopping Bag' : 'Sold Out';

          if (variant.featured_image && mainImage) {
            mainImage.src = variant.featured_image.src || variant.featured_image;
            mainImage.alt = product.title;
          }
          return;
        }

        const selected = {};
        inputs.forEach((input) => {
          if (input.checked) selected[Number(input.dataset.optionPosition) - 1] = input.value;
        });

        // Only keep options that lead to an available variant when combined with the other selections.
        inputs.forEach((input) => {
          const optionIndex = Number(input.dataset.optionPosition) - 1;
          const candidateValue = input.value;
          const possible = product.variants.some((candidate) => {
            if (!isUsableVariant(product, candidate)) return false;
            return candidate.options.every((candidateValueAtIndex, index) => {
              if (index === optionIndex) return candidateValueAtIndex === candidateValue;
              return !selected[index] || selected[index] === candidateValueAtIndex;
            });
          });
          input.disabled = !possible;
          const pill = input.nextElementSibling;
          if (pill) {
            pill.classList.toggle('opacity-40', !possible);
            pill.classList.toggle('line-through', !possible);
          }
          input.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });

        let variant = product.variants.find((candidate) =>
          candidate.options.every((value, index) => selected[index] === value)
        );

        if (!isUsableVariant(product, variant)) {
          const fallback = product.variants.find((candidate) => isUsableVariant(product, candidate));
          if (fallback) {
            inputs.forEach((input) => {
              const position = Number(input.dataset.optionPosition) - 1;
              input.checked = fallback.options[position] === input.value;
            });
            Object.keys(selected).forEach((key) => delete selected[key]);
            inputs.forEach((input) => {
              if (input.checked) selected[Number(input.dataset.optionPosition) - 1] = input.value;
            });
            variant = fallback;
          }
        }

        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (label) label.textContent = 'Unavailable';
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceBox) {
          const price = formatMoney(variant.price);
          const compare = variant.compare_at_price > variant.price
            ? `<span class="text-sm text-[#8C7B6B] line-through">${formatMoney(variant.compare_at_price)}</span>`
            : '';
          priceBox.innerHTML = `<span class="text-2xl font-bold text-[#1A1918]">${price}</span>${compare}<span class="text-[10px] bg-[#E8DFD1] text-[#1A1918] font-bold px-2 py-0.5 rounded uppercase">Cash on Delivery</span>`;
        }

        if (addButton) addButton.disabled = !variant.available;
        if (label) label.textContent = variant.available ? 'Add to Shopping Bag' : 'Sold Out';

        if (variant.featured_image && mainImage) {
          mainImage.src = variant.featured_image.src || variant.featured_image;
          mainImage.alt = product.title;
        }
      };

      inputs.forEach((input) => input.addEventListener('change', sync));
      sync();
    });
  }


  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!quantityButton) return;

    const section = quantityButton.closest('[data-product-section]');
    const input = section?.querySelector('#ProductQuantity, [name="quantity"]');
    if (!input) return;

    const min = Number(input.min || 1);
    const max = input.max ? Number(input.max) : Infinity;
    const step = Number(input.step || 1);
    const current = Number(input.value || min);
    const next = quantityButton.hasAttribute('data-quantity-plus')
      ? current + step
      : current - step;

    input.value = String(Math.min(max, Math.max(min, Number.isFinite(next) ? next : min)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });


  document.addEventListener('click', (event) => {
    const logo = event.target.closest('[data-home-logo]');
    if (!logo || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    const homeUrl = logo.href || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || routes.root_url || '/');
    window.location.assign(homeUrl);
  });

  document.addEventListener('click', async (event) => {
    const openCartTrigger = event.target.closest('[data-open-cart-drawer], #cartOpen');
    if (openCartTrigger) {
      event.preventDefault();
      openCart();
      return;
    }

    if (event.target.closest('[data-close-cart], [data-cart-overlay]')) {
      closeCart();
      return;
    }

    const lineButton = event.target.closest('[data-cart-increase], [data-cart-decrease], [data-cart-remove]');
    if (lineButton) {
      if (cartMutationInFlight) return;
      const line = Number(lineButton.dataset.line);
      const item = lineButton.closest('[data-cart-item]');
      const qtyEl = item?.querySelector('[data-line-quantity]');
      const currentQuantity = Number(qtyEl?.textContent || item?.dataset.quantity || 1);
      if (!line || !Number.isFinite(currentQuantity)) return;

      let nextQuantity = currentQuantity;
      if (lineButton.hasAttribute('data-cart-remove')) nextQuantity = 0;
      else if (lineButton.hasAttribute('data-cart-increase')) nextQuantity += 1;
      else nextQuantity = Math.max(0, nextQuantity - 1);

      lineButton.disabled = true;
      try {
        await runCartMutation(async () => {
          const cart = await changeCart(line, nextQuantity);
          renderCart(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        });
      } catch (_) {
        showToast('We could not update your shopping bag. Please try again.');
      } finally {
        lineButton.disabled = false;
      }
      return;
    }

    const quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault();
      if (quickAdd.disabled) return;

      quickAdd.disabled = true;
      try {
        await addToCart(quickAdd.dataset.variantId);
        openCart();
        showToast('Added to your shopping bag.');
      } catch (error) {
        showToast(error.message || 'Unable to add this item.');
      } finally {
        quickAdd.disabled = false;
      }
      return;
    }

    const quickView = event.target.closest('[data-quick-view]');
    if (quickView) {
      event.preventDefault();
      await openQuickView(quickView.dataset.productUrl, quickView);
      return;
    }

    if (event.target.closest('[data-close-quick-view], [data-quick-view-overlay]')) {
      closeQuickLayer();
      return;
    }

    if (event.target.closest('#mobileMenuOpen')) {
      setMobileMenu(true);
      return;
    }

    if (event.target.closest('[data-mobile-menu-close]')) {
      setMobileMenu(false);
      return;
    }

    if (event.target.closest('#searchOpen')) {
      openSearch();
      return;
    }

    if (event.target.closest('[data-close-search], [data-search-overlay]')) {
      closeSearch();
      return;
    }

    const media = event.target.closest('[data-media-src]');
    if (media) {
      const image = $('#ProductMainImage');
      if (image) {
        image.src = media.dataset.mediaSrc;
        image.alt = media.dataset.mediaAlt || '';
      }
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;

    event.preventDefault();

    const button = $('[data-add-to-cart]', form);
    const errorBox = $('[data-product-form-error]', form);
    const data = new FormData(form);
    const id = data.get('id');
    const quantity = Number(data.get('quantity') || 1);

    if (!id) return;

    if (button) button.disabled = true;
    errorBox?.classList.add('hidden');

    try {
      await addToCart(id, quantity);
      openCart();
    } catch (error) {
      if (errorBox) {
        errorBox.textContent = error.message;
        errorBox.classList.remove('hidden');
      } else {
        showToast(error.message || 'Unable to add this item.');
      }
    } finally {
      if (button) button.disabled = false;
    }
  });

  $('#quickViewForm')?.addEventListener('submit', async (event) => {
    event.preventDefault();

    const variantId = $('#quickViewVariant')?.value;
    const quantity = Number($('#quickViewQuantity')?.value || 1);
    const button = $('#quickViewAdd');

    if (!variantId || !activeQuickProduct) return;

    if (button) {
      button.disabled = true;
      button.textContent = 'ADDING…';
    }

    try {
      await addToCart(variantId, quantity);
      closeQuickLayer();
      openCart();
      showToast('Added to your shopping bag.');
    } catch (error) {
      showToast(error.message || 'Unable to add this item.');
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = 'ADD TO SHOPPING BAG';
      }
    }
  });

  // The modal uses data attributes so the controls remain compatible with theme editor reloads.
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-qv-qty-minus]')) {
      const input = $('#quickViewQuantity');
      if (input) input.value = Math.max(1, Number(input.value || 1) - 1);
    }
    if (event.target.closest('[data-qv-qty-plus]')) {
      const input = $('#quickViewQuantity');
      if (input) input.value = Math.max(1, Number(input.value || 1) + 1);
    }
  });

  const input = $('#PredictiveSearchInput');
  input?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const query = input.value.trim();
    const output = $('[data-predictive-results]');
    if (!output) return;

    if (!query) {
      output.innerHTML = '<span class="text-[11px] font-bold uppercase tracking-widest text-[#8C7B6B]">Start typing to search products</span>';
      return;
    }

    searchTimer = setTimeout(async () => {
      try {
        const endpoint = `${routes.predictive_search_url || '/search/suggest'}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');

        const data = await response.json();
        const products = data.resources?.results?.products || [];

        output.innerHTML = products.length
          ? `<div class="grid grid-cols-2 sm:grid-cols-3 gap-4">${products.map((product) => `
              <a href="${product.url}" class="block">
                <img src="${product.image || ''}" alt="${escapeHtml(product.title)}" class="w-full aspect-square object-cover rounded mb-2" loading="lazy">
                <span class="text-xs font-semibold">${escapeHtml(product.title)}</span>
              </a>`).join('')}</div>
             <a href="${routes.search_url || '/search'}?q=${encodeURIComponent(query)}&type=product" class="block mt-5 text-center text-xs underline">View all results</a>`
          : '<p class="text-xs text-[#8C7B6B]">No products found.</p>';
      } catch (_) {
        output.innerHTML = '<p class="text-xs text-[#8C7B6B]">Search is unavailable. Press Enter to view results.</p>';
      }
    }, 220);
  });

  input?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && input.value.trim()) {
      window.location.href = `${routes.search_url || '/search'}?q=${encodeURIComponent(input.value.trim())}&type=product`;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    if (quick?.classList.contains('is-open')) closeQuickLayer();
    else if (drawer?.classList.contains('is-open')) closeCart();
    else if (isSearchOpen()) closeSearch();
    else if (isMobileMenuOpen()) setMobileMenu(false);
  });

  initProductForms();
  initWishlist();
})();
